import style from './style.module.css';

const AccountCard = ({ data }) => {
    // Разбиваем строку описания на элементы по запятой
    const descriptionItems = data.description.split(',').map(item => item.trim());

    return (
        <div className={style.account_card}>
            <div className={style.account_card__info}>
                <img className={style.account_card__image} src={data.images} alt='price' />
                <h4 className={style.training_title}>{data.name}</h4>
                <div className={style.training_details}>
                    <span className={style.training_rank}>{data.rank}</span>
                    <span className={style.training_hours}>{data.hours}</span>
                </div>
                <ul className={style.training_desc_list}>
                    {descriptionItems.map((item, index) => (
                        <li key={index} className={style.training_desc_item}>
                            {item}
                        </li>
                    ))}
                </ul>
                <span className={style.account_card__price}>
                    Стоимость: {data.price}₽
                </span>
            </div>
        </div>
    );
};

export default AccountCard;